import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../Button';

export type selectableColumnIndexProps = 0 | 1 | 2 | 3;

export type plansDataProps = {
  planNames: string[];
  planPrices: string[];
};

export type customPlanSelectionProps = {
  selectedPlanIndex?: selectableColumnIndexProps;
  plansData: plansDataProps;
};

const ExpandableContentPlanSelection = ({
  selectedPlanIndex,
  plansData,
}: customPlanSelectionProps) => {
  const [plansDataStored, setPlansDataStored] = React.useState<{
    [key: string]: string[];
  }>(plansData);

  useEffect(() => {
    if (plansData) {
      setPlansDataStored(plansData);
    }
  }, [plansDataStored, plansData]);

  return (
    <>
      {plansDataStored ? (
        <Container className="custom-plan-selection-container">
          <Row className="m-0 p-10 p-lg-0 plans-row">
            <Col className="p-0 d-lg-flex align-items-lg-center plans-col">
              {plansDataStored.planNames.map((planName, index) => (
                <Col
                  md={3}
                  lg={3}
                  className={`plans-cols ${
                    index === selectedPlanIndex ? 'selected' : ''
                  }`}
                  key={index}
                >
                  {planName}
                </Col>
              ))}
            </Col>
            <Col className="p-0 d-lg-flex align-items-lg-center price-col">
              {plansDataStored.planPrices.slice(1).map((planPrice, index) => (
                <Col
                  md={3}
                  lg={3}
                  className={`price-cols ${
                    index === selectedPlanIndex ? 'selected' : ''
                  }`}
                  key={index}
                >
                  {planPrice}
                </Col>
              ))}
            </Col>
          </Row>
          <Row className="m-0 btns-row">
            <Col className="p-10 d-lg-flex align-items-lg-center justify-content-lg-evenly">
              <Row className="m-0 pb-4 pb-lg-0 pr-lg-4">
                <Button
                  variant="primary"
                  rightIcon={light('file-pdf')}
                  size="sm"
                  className="d-flex justify-content-center "
                >
                  Plan Details
                </Button>
              </Row>
              <Row className="m-0">
                <Button
                  variant="primary-outline"
                  rightIcon={light('scale-balanced')}
                  size="sm"
                  className="d-flex justify-content-center "
                >
                  Compare Plans
                </Button>
              </Row>
            </Col>
          </Row>
        </Container>
      ) : (
        <h1>NO DATA</h1>
      )}
    </>
  );
};

export default ExpandableContentPlanSelection;
